import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, ResolveFn, RouterStateSnapshot } from '@angular/router';
import { Observable, of } from 'rxjs';
import { KeplerService } from '../services/kepler.service';
import { KeplerMatch } from '../models/KeplerMatch';

export const KeplerMatchResolver: ResolveFn<any> = (
  route?: ActivatedRouteSnapshot,
  state?: RouterStateSnapshot,
  keplerService: KeplerService = inject(KeplerService)
): Observable<KeplerMatch> => {
  const matchId = route.paramMap.get('matchId') || route.queryParamMap.get('matchId');
  if (matchId) {
    return keplerService.getKeplerMatch$(matchId);
  }

  return of(null as any);
};
